// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__35wzN","addWidgetButton":"Header_addWidgetButton__19j23","dashboardTabs":"Header_dashboardTabs__2RXbx","active":"Header_active__6D0-P"};